
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/building/[sid]/street",
      function () {
        return require("private-next-pages/building/[sid]/street.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/building/[sid]/street"])
      });
    }
  